import { createMD5 } from "hash-wasm";

export const getHash = async (file: File): Promise<string> => {
  const hasher = await createMD5();

  hasher.init();

  await readFile(file, (result: ArrayBuffer) => {
    hasher.update(new Uint8Array(result));
  });

  return hasher.digest();
};

const readFile = async (file: File, callback: Function): Promise<void> => {
  const chunkSize = 20971520; // 1024 * 1024 * 20

  let offset = 0;

  while (offset < file.size) {
    // eslint-disable-next-line
    callback(await file.slice(offset, offset + chunkSize).arrayBuffer())

    offset += chunkSize;
  }
};
